<template>
  <div class="payments-list-page fixed-draggable-dynamic-table-wrapper-height">
    <draggable-dynamic-table ref="paymentsList"
                             :options="options"
                             :columns="columnsLabel"
                             :data="data"
                             :zero-top-radius="true"
                             @filter:remove="setFilters($event)"
                             @filter:set="setFilters($event)"
                             @sort:set="setSort($event)"
                             @load:more="getPayments()"/>

    <button id="printTablePayment" v-show="false" @click="handlePrintPayment"></button>
  </div>
</template>

<script>
import axios from 'axios'
import {getDocuments, getPaymentPrice} from '@/http/requests/documents'
import {addComma, getTimeFromServer, hideLoading, showLoading} from "../../../../../assets/js/functions";
import {printPayment} from "../../../../../http/requests/documents";
import {getBanks} from "../../../../../http/requests/banks";
import {getCashBoxes} from "../../../../../http/requests/cashBoxes";

export default {
  name: 'paymentsList',
  metaInfo () {
    return {
      title: this.$t('treasury.payment.list.title')
    }
  },
  data () {
    return {
      loadingTimer: 0,
      priceRequestSent: false,
      options: {
        id: 'paymentsList',
        rowKeyField: 'id'
      },
      columnsLabel: [
        {
          field: 'price',
          i18n: 'treasury.payment.table.header.price',
          width: 'calc(100% / 9)',
          minWidth: 120,
          sortable: true,
          filter: true,
          filterTypes: [
            {
              icon: 'equals',
              name: 'برابر باشد',
              i18n: 'draggableTable.filter.types.equals',
              id: 1
            },
            {
              icon: 'not-equal',
              name: 'برابر نباشد',
              i18n: 'draggableTable.filter.types.notEqual',
              id: 2
            },
            {
              icon: 'less-than-equal',
              name: 'کوچکتر مساوی',
              i18n: 'draggableTable.filter.types.lessThanEquals',
              id: 4
            },
            {
              icon: 'greater-than-equal',
              name: 'بزرگتر مساوی',
              i18n:
                'draggableTable.filter.types.greaterThanEquals',
              id: 3
            }
          ],
          footer: {}
        },
        /*{
          field: 'description',
          i18n: 'treasury.payment.table.header.description',
          width: 'calc(100% / 9 * 2)',
          minWidth: 200,
          locked: true,
          sortable: true,
          align: 'center',
          filter: true,
          filterTypes: [
            {
              icon: 'search',
              name: 'شامل شود',
              i18n: 'draggableTable.filter.types.search',
              id: 1
            }
          ]
        },*/
        {
          field: 'payee',
          i18n: 'treasury.payment.table.header.destination',
          width: 'calc(100% / 9 * 2)',
          minWidth: 150,
          locked: true,
          sortable: true,
          align: 'center',
          filter: true,
          filterTypes: [
            {
              icon: 'search',
              name: 'شامل شود',
              i18n: 'draggableTable.filter.types.search',
              id: 1
            }
          ]
        },
        {
          field: 'payer',
          i18n: 'treasury.payment.table.header.source',
          width: 'calc(100% / 9 * 2)',
          minWidth: 150,
          locked: true,
          sortable: true,
          align: 'center',
          filter: true,
          filterType: 'select',
          filterTypes: [
            {
              label: this.$t('treasury.payment.labels.all'),
              value: ''
            }
          ]
        },
        {
          field: 'creator',
          i18n: 'treasury.payment.table.header.creator',
          width: 'calc(100% / 9 * 2)',
          minWidth: 150,
          locked: true,
          sortable: true,
          align: 'center',
          filter: true,
          filterTypes: [
            {
              icon: 'search',
              name: 'شامل شود',
              i18n: 'draggableTable.filter.types.search',
              id: 1
            }
          ]
        },
        {
          field: 'date',
          i18n: 'treasury.payment.table.header.date',
          width: 'calc(100% / 9)',
          minWidth: 130,
          locked: true,
          sortable: true,
          align: 'center',
          filter: true,
          filterType: 'date',
          filterRange: true
        },
        {
          field: 'id',
          i18n: 'treasury.payment.table.header.docNumber',
          width: 'calc(100% / 9)',
          minWidth: 80,
          locked: true,
          align: 'center',
          sortable: true,
          filter: true,
          filterTypes: [
            {
              icon: 'equals',
              name: 'برابر باشد',
              i18n: 'draggableTable.filter.types.equals',
              id: 1
            },
            {
              icon: 'not-equal',
              name: 'برابر نباشد',
              i18n: 'draggableTable.filter.types.notEqual',
              id: 2
            },
            {
              icon: 'less-than-equal',
              name: 'کوچکتر مساوی',
              i18n: 'draggableTable.filter.types.lessThanEquals',
              id: 4
            },
            {
              icon: 'greater-than-equal',
              name: 'بزرگتر مساوی',
              i18n:
                'draggableTable.filter.types.greaterThanEquals',
              id: 3
            }
          ],
          footer: {
            type: 'auto-counter'
          }
        }
      ],
      sourceTypesMapper: {
        'User': this.$t('treasury.payment.types.user'),
        'Bank': this.$t('treasury.payment.types.bank'),
        'Cash': this.$t('treasury.payment.types.cash'),
        'Storeroom': this.$t('treasury.payment.types.storeroom'),
        'PaymentGateway': this.$t('treasury.payment.types.paymentGateway')
      },
      data: [],
      sorts: ['order[0]=date,desc'],
      filters: [],
      page: 1,
      endedList: false,
      requestSent: false,
      actions: [
        {
          toolbar: [
            {
              id: {name: 'insertTreasuryPayment'},
              type: 'link',
              icon: 'icon-plus',
              iconPack: 'feather',
              color: 'success',
              permission: ['payment.create']
            }
          ],
          leftToolbar: [
            // {
            //   id: 'printTablePayment',
            //   // i18n: 'draggableDynamicTable.actions.print',
            //   icon: 'icon-printer',
            //   iconPack: 'feather'
            // },
            {
              id: 'downloadTable',
              // i18n: 'draggableDynamicTable.actions.download',
              icon: 'icon-download',
              iconPack: 'feather'
            },
            {
              id: 'settingTable',
              icon: 'icon-settings',
              iconPack: 'feather'
            }
          ]
        }
      ]
    }
  },
  created () {
    setTimeout(() => {
      this.$store.dispatch('updateNavbarActions', this.actions[0])
      this.$store.dispatch('updateContentNavbarStyle', 'sticky')
    }, 50)

    this.getBanksFilters()
    this.getCashBoxFilters()
    this.getPayments()
  },
  methods: {
    getPayments () {
      if (!this.requestSent) {
        this.requestSent = true

        clearTimeout(this.loadingTimer)
        this.loadingTimer = setTimeout(() => {
          if (!this.endedList) {
            if (this.$refs.paymentsList && this.data.length === 0) this.$refs.paymentsList.loadMoreStatus = 'FirstLoad'
            else if (this.$refs.paymentsList && this.data.length > 0) this.$refs.paymentsList.loadMoreStatus = 'Loading'

            getDocuments('payment', this.page, this.filters, this.sorts).then(response => {
              this.endedList = response.data.data.length === 0
              const documents = response.data.data
              documents.forEach((document) => {
                this.data.push({
                  route: {
                    name: 'treasuryPaymentDocument',
                    params: {id: document.id}
                  },
                  id: document.document_id,
                  creator: `${document.creator.name}`,
                  description: document.description,
                  payer: document.payer.name || '',
                  payee: `${document.payee.name || ''} ${document.payee.family || ''}`,
                  price: {
                    type: 'price',
                    value: document.final_price || document.price
                  },
                  type: document.type,
                  date: document.date
                })
              })

              this.page = response.data.pagination.current_page + 1
              if (response.data.pagination.current_page === 1) {
                const row_index = this.columnsLabel.map((e) => {
                  return e.field
                }).indexOf('id')
                this.columnsLabel[row_index].footer.value = response.data.pagination.total
              }

              if (this.$refs.paymentsList) this.$refs.paymentsList.loadMoreStatus = ''
              this.requestSent = false
            }).catch((error) => {
              if (axios.isCancel(error)) {
                this.$vs.notify({
                  title: this.$t('alert.duplicateRequest.title'),
                  text: this.$t('alert.duplicateRequest.message'),
                  icon: 'icon-alert-circle',
                  iconPack: 'feather',
                  time: 2400,
                  color: 'warning'
                })
              }
              this.requestSent = false

              if (this.$refs.paymentsList)
              this.$refs.paymentsList.loadMoreStatus = 'Danger'
            })
          } else {
            this.requestSent = false
          }
        }, 400)
      }
    },
    getPaymentPrice () {
      if (!this.priceRequestSent) {
        this.priceRequestSent = true
        getPaymentPrice(this.filters).then(response => {
          this.priceRequestSent = false
          const price_index = this.columnsLabel.map((e) => {
            return e.field
          }).indexOf('price')
          this.columnsLabel[price_index].footer = {
            value: addComma(response.data.data.total)
          }
        })
          .catch(() => {
            this.priceRequestSent = false
          })
      }
    },
    setFilters (filters) {
      const filters_list = []
      Object.keys(filters).forEach((key) => {
        switch (key) {

          case 'id':
            if (filters[key].search !== '') filters_list.push(`document=${  filters[key].search},${  filters[key].type.id}`)
            break

          case 'creator':
            if (filters[key].search !== '') filters_list.push(`creator=${  filters[key].search}`)
            break

          case 'description':
            if (filters[key].search !== '') filters_list.push(`description=${  filters[key].search}`)
            break

          case 'price':
            if (filters[key].search !== '') filters_list.push(`final_price=${  filters[key].search},${  filters[key].type.id}`)
            break

          case 'payer':
            if (filters[key].search.value.length > 0) filters_list.push(`payer=${  filters[key].search.value }`)
            break

          case 'payee':
            if (filters[key].search !== '') filters_list.push(`payee=${  filters[key].search }`)
            break

          case 'date':
            if (filters[key].search.length > 0) filters_list.push(`date=${  filters[key].search.join('_')}`)
            break
        }
      })

      this.data = []
      this.page = 1
      this.endedList = false
      this.filters = filters_list
      this.getPayments()
      this.getPaymentPrice()
    },
    setSort (columns) {
      const sorts_list = []
      Object.keys(columns).forEach((key) => {
        switch (key) {

          case 'id':
            sorts_list.push(`order[0]=document_id,${  columns[key] ? 'desc' : 'asc'}`)
            break

          case 'creator':
            sorts_list.push(`order[0]=creator,${  columns[key] ? 'desc' : 'asc'}`)
            break

          case 'description':
            sorts_list.push(`order[0]=description,${  columns[key] ? 'desc' : 'asc'}`)
            break

          case 'price':
            sorts_list.push(`order[0]=final_price,${  columns[key] ? 'desc' : 'asc'}`)
            break

          case 'payer':
            sorts_list.push(`order[0]=payer_id,${  columns[key] ? 'desc' : 'asc'}`)
            break

          case 'payee':
            sorts_list.push(`order[0]=payee_id,${  columns[key] ? 'desc' : 'asc'}`)
            break

          case 'date':
            sorts_list.push(`order[0]=date,${  columns[key] ? 'desc' : 'asc'}`)
            break
        }
      })

      if (!sorts_list.length) sorts_list.push('order[0]=created_at,desc')

      this.data = []
      this.page = 1
      this.endedList = false
      this.sorts = sorts_list
      this.getPayments()
    },
    handlePrintPayment () {
      showLoading()

      printPayment(this.filters, this.sorts).then(response => {
        hideLoading()

        const data = response.data

        let time = getTimeFromServer()
        let fileURL = window.URL.createObjectURL(new Blob([data]));
        let fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', `paymentList-${ time }.pdf`);
        document.body.appendChild(fileLink);
        fileLink.click();
      })
        .catch((error) => {
          hideLoading()

          if (axios.isCancel(error)) {
            this.$vs.notify({
              title: this.$t('alert.duplicateRequest.title'),
              text: this.$t('alert.duplicateRequest.message'),
              icon: 'icon-alert-circle',
              iconPack: 'feather',
              time: 2400,
              color: 'warning'
            })
          } else {
            this.$vs.notify({
              title: this.$t('alert.error.title'),
              text: this.$t('treasury.payment.notifications.print.error'),
              color: 'danger',
              time: 2400,
              icon: 'icon-alert-circle',
              iconPack: 'feather'
            })
          }
        })
    },
    getBanksFilters () {
      getBanks().then(response => {
        const banks = response.data.data
        const payerIndex = this.columnsLabel.map(e => e.field).indexOf('payer')
        banks.forEach((bank) => {
          if (payerIndex > -1) {
            this.columnsLabel[payerIndex].filterTypes.push({
              label: bank.name,
              value: bank.name
            })
          }
        })
      })
    },
    getCashBoxFilters () {
      getCashBoxes().then(response => {
        const cashBoxes = response.data.data
        const payerIndex = this.columnsLabel.map(e => e.field).indexOf('payer')
        cashBoxes.forEach((cashBox) => {
          if (payerIndex > -1) {
            this.columnsLabel[payerIndex].filterTypes.push({
              label: cashBox.name,
              value: cashBox.name
            })
          }
        })
      })
    }
  }
}
</script>

<style scoped>

</style>
